import axiosClient from '../axiosClient';

export const userApi = {
    async getInfomation() {
        const url = '/informations';
        return axiosClient.get(url);
    },
};
